/*=============================================== InputSliderPage ===============================================*/

import { useState } from "react"
import type { ChangeEvent } from "react"
import { InputSlider } from "tsx-library-julseb"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

import { inputLabel, validationStatus } from "data"

const InputSliderPage = () => {
    const [value, setValue] = useState<number>(50)
    const handleChange = (e: ChangeEvent<HTMLInputElement>) =>
        setValue(parseFloat(e.target.value))

    const items: ItemType[] = [
        {
            content: (
                <InputSlider
                    value={value}
                    onChange={handleChange}
                    showMinMax
                    label="Range"
                    showValue="hover"
                />
            ),
            code: 'const [value, setValue] = useState(50)\nconst handleChange = e => setValue(parseFloat(e.target.value))\n\n<InputSlider value={value} onChange={handleChange} label="Range" showValue="hover" showMinMax />',
            codeTs: 'const [value, setValue] = useState<number>(50)\nconst handleChange = (e: ChangeEvent<HTMLInputElement>) => setValue(parseFloat(e.target.value))\n\n<InputSlider value={value} onChange={handleChange} label="Range" showValue="hover" showMinMax />',
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "showMinMax",
            type: "boolean",
        },
        {
            subtitle: "showValue",
            type: "string",
            possible: ["never", "always", "hover"],
            default: "never",
        },
        validationStatus,
        ...inputLabel(),
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default InputSliderPage
